<template>
    <div class="news-details-content">

        <el-affix :z-index="maxZIndex">
            <NavBar></NavBar>
        </el-affix>

        <div class="main">
            <Breadcrumb :bread-list="breadList"></Breadcrumb>

            <div class="news-details">
                <div class="title">{{ details?.title }}</div>
                <div class="sub-content">
                    <div class="views">{{$t('newsDetails.views')}}：{{ details?.views }}</div>
                    <div class="author">{{ $t('newsDetails.author')  }}：{{details?.author }}</div>
                    <div class="createTime">{{ $t('newsDetails.createTime') }}：{{ UtilMethods.formatDataOfPattern(details?.createTime,'YYYY/MM/DD') }}</div>
                </div>

                <div class="content" v-html="details?.content">
                </div>
            </div>
        </div>

        <Footer></Footer>
    </div>
</template>

<script lang="ts" setup>
import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { router } from '@/router';
import { Action } from '@/typeDefine/CommonTypes';
import { GetNewsDetailsResponse } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { onMounted, ref, Ref } from 'vue';
import { useRoute } from 'vue-router';
import NavBar from '@/components/NavBar.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Footer from '@/components/Footer.vue';
import { BreadType } from '@/typeDefine/EntityType';

const route = useRoute()
const maxZIndex: string = UtilMethods.getDOMStyleFromCSS('--max-z-index')

const breadList: BreadType[] = [
    {
        to: '/newsList',
        text: 'index.navBar.news'
    },
    {
        text: 'index.navBar.newsDetails'
    }
]
const details: Ref<GetNewsDetailsResponse['data']['details'] | null> = ref(null)

onMounted(() => {

    if (typeof route.params.id === 'string') {
        requestNewsDetails(route.params.id)
    }

})

//获取新闻详情
const requestNewsDetails: Action<[string]> = async (id: string) => {
    const response: GetNewsDetailsResponse = await Api.instance.getNewsDetails({
        id,
    })

    UtilMethods.showMessageToast(response,false)
    if(response.code === ResponseCode.OK) {
        details.value = response.data.details
    }else {
        router.replace({
            name: 'newsList'
        })
    }
}
</script>

<style lang="css" scoped>
.news-details-content .main {
    width: 90%;
    margin: 0 auto;
}
.news-details-content .main .news-details {
    margin: 50px 0;
}
.news-details-content .main .news-details .title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
}
.news-details-content .main .news-details .sub-content {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    font-size: 14px;
    color: #333;
}
.news-details-content .main .news-details .sub-content div {
    margin-right: 20px;
}
.news-details-content .main .news-details .content {
    margin-top: 30px;
}

</style>

<style>
.news-details-content .main .news-details .content img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 8px 0;
  object-fit: contain;
}
</style>